<template>
  <button @click="open" class="btn btn-sm btn-info mr-1 mb-1">
    <font-awesome-icon icon="mobile" />&nbsp;{{ $t('device') }}
    <b-modal v-model="showForm" size="lg" no-close-on-backdrop no-enforce-focus :title="$t('deviceHistory')">
      <div class="">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>{{ $t('device') }}</th>
              <th>{{ $t('ipAddress') }}</th>
              <th>{{ $t('loginTime') }}</th>
              <th>{{ $t('lastRequestTime') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="items.length">
            <tr v-for="item in items" :key="item._id">
              <td>
                <span>{{ getDeviceName(item.ua) }}</span>
              </td>
              <td>{{ item.ip }}</td>
              <td>{{ item.createTime | moment('HH:mm:ss DD/MM/YYYY') }}</td>
              <td>{{ item.lastRequestTime | moment('HH:mm:ss DD/MM/YYYY') }}</td>
              <td class="text-right">
                <button class="btn btn-sm btn-danger" @click="deleteToken(item._id)">
                  <i class="fa fa-trash mr-0" />
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="text-center text-gray-999">{{ $t('noDeviceFound') }}</td>
            </tr>
          </tbody>

        </table>
      </div>
      <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
        <b-pagination size="sm" class="pagination pagination-sm justify-content-center" v-model="filterFormModel.page"
          :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load">
        </b-pagination>
      </div>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('close') }}</button>
      </template>
    </b-modal>
  </button>
</template>
<script>
import List from '@/mixins/List';
import parser from 'ua-parser-js';

export default {
  props: ['user'],
  mixins: [List],
  data() {
    return {
      showForm: false,
      service: `/client-user/${this.user._id}/token`,
      autoLoad: false,
      defaultFilterFormModel: {
        user: this.user._id
      }
    }
  },
  methods: {
    open: function () {
      this.showForm = true;
      this.load();
    },
    getDeviceName: function (userAgent) {
      let uaInfo = new parser(userAgent);
      return uaInfo.getOS().name + ' ' + uaInfo.getOS().version + ', ' + uaInfo.getBrowser().name;
    },
    deleteToken: function (id) {
      this.$swal({
        title: this.$t('deleteConfirm'),
        text: this.$t('deleteAlert'),
        icon: 'warning',
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.$service.delete(`/client-user/token/${id}`).then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                icon: 'success',
                title: this.$t('success'),
                text: this.$t('deleted'),
                timer: 3000,
              });
            }
          });
        }
      });
    },
  },
  i18n: {
    messages: {
      vi: {
        device: "Thiết bị",
        deviceHistory: "Lịch sử thiết bị",
        ipAddress: "Địa chỉ IP",
        loginTime: "Đăng nhập lúc",
        lastRequestTime: "Hoạt động cuối lúc",
        close: "Đóng",
        noDeviceFound: "Không tìm thấy thiết bị nào",
        deleteConfirm: "Xác nhận xoá",
        deleteAlert: "Bạn có chắc chắn muốn xoá thiết bị này?",
        deleted: "Đã xoá thiết bị thành công"
      },
      en: {
        device: "Device",
        deviceHistory: "Device history",
        ipAddress: "IP address",
        loginTime: "Login at",
        lastRequestTime: "Last request at",
        close: "Close",
        noDeviceFound: "Not found any device",
        deleteConfirm: "Confirm delete",
        deleteAlert: "Are you sure you want to delete this device?",
        deleted: "Device deleted successfully"
      },
    }
  }
}
</script>
